import { EventEmitter } from './EventEmitter';

export const GlobalEmitter = new EventEmitter();
